import { Button } from '@octopus-do/octopus-storybook'
import { CloudArrowUp } from '@octopus-do/octopus-storybook/icons'
import { useProjectBaseActions } from '@store/migrationActions/useProjectBaseActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import clsJoin from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'
import css from './styles.module.css'

export const SaveProject: React.FC = () => {
  const loading = useSelector(selectIsLoading('project_save'))

  const { saveProject } = useProjectBaseActions()

  const unsaved = useSelector(
    migrationProjectSelector.getProjectHasChangesAndNotSaved
  )

  const trial = useSelector(migrationProjectSelector.getProjectIsTrial)

  // Visibility and the pulse live on a wrapper: the kit button sets its own
  // display and box-shadow, and a class on it wins or loses by CSS order.
  const containerClass = clsJoin(
    css.saveBtn,
    unsaved && !loading && css.animate,
    trial && !loading && css.blink
  )

  return (
    <div className={containerClass}>
      <Button
        size="medium"
        label="Save"
        left={CloudArrowUp}
        loading={loading}
        data-testid="share"
        onClick={() => saveProject()}
      />
    </div>
  )
}
